import { TakeoutOrderStatus, ViewMenuTakeoutStatus } from '../models';

export type OrderMessage = {
  paid: string;
  unpaid: string;
};

export class TakeoutDeliveryConstant {
  static readonly VIEW_MENU_TAKEOUT_STATUS: ViewMenuTakeoutStatus[] = [
    TakeoutOrderStatus.SCHEDULED,
    TakeoutOrderStatus.IN_PRODUCTION,
    TakeoutOrderStatus.PRODUCTION_COMPLETE
  ];

  static readonly ViewMenuItemMessage: Record<
    ViewMenuTakeoutStatus,
    OrderMessage
  > = {
    [TakeoutOrderStatus.SCHEDULED]: {
      paid: 'takeout.orderScheduledPaid',
      unpaid: 'takeout.orderScheduled'
    },
    [TakeoutOrderStatus.IN_PRODUCTION]: {
      paid: 'takeout.orderInProduction',
      unpaid: 'takeout.orderInProduction'
    },
    [TakeoutOrderStatus.PRODUCTION_COMPLETE]: {
      paid: 'takeout.orderCompletePaid',
      unpaid: 'takeout.orderCompleteNeedsPayment'
    }
  };

  static readonly ORDER_STATUS_TRANSLATION_KEYS: Record<
    TakeoutOrderStatus,
    string
  > = {
    [TakeoutOrderStatus.ORDER_ENTRY]: 'takeout.statusOrderEntry',
    [TakeoutOrderStatus.SCHEDULED]: 'takeout.statusScheduled',
    [TakeoutOrderStatus.IN_PRODUCTION]: 'takeout.statusInProduction',
    [TakeoutOrderStatus.PRODUCTION_COMPLETE]:
      'takeout.statusProductionComplete',
    [TakeoutOrderStatus.OUT_FOR_DELIVERY]: 'takeout.statusOutForDelivery',
    [TakeoutOrderStatus.COMPLETED]: 'takeout.statusCompleted'
  };
}
